export default function CompanyIntro() {
  return (
    <section id="story" className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-3">
            Our Story
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
            关于<span className="text-primary-500">今日看料</span>
          </h2>
          <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
            今日看料创立于2023年，致力成为中国领先的娱乐资讯聚合平台。我们以"让每一颗瓜都新鲜"为使命，7x24小时追踪网络热点，为吃瓜群众提供最新、最全、最真实的娱乐资讯和网红爆料。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
            <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
              <i className="ri-rocket-2-line text-xl text-primary-600"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">品牌使命</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              让每一位吃瓜群众都能在第一时间获取真实、全面、有深度的热点资讯。我们坚信，信息透明是互联网时代最宝贵的财富。
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
            <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
              <i className="ri-eye-line text-xl text-accent-600"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">品牌愿景</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              打造中文互联网最具影响力的娱乐资讯平台，成为1亿吃瓜群众的每日必看。从热点追踪到深度分析，构建完整的内容生态。
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
            <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-secondary-100 flex items-center justify-center">
              <i className="ri-shield-check-line text-xl text-secondary-600"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">品牌价值观</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              真实、客观、公正。我们严格审核每一条信息来源，坚持为用户提供经得起验证的资讯内容，拒绝谣言和虚假信息。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}